import {
  Task,
  TaskListItem,
  TaskFilters,
  CreateTaskDto,
  UpdateTaskDto,
  CompleteTaskDto,
  ScheduleTaskDto,
  StartTaskDto,
  TechnicianTasksResponse,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";
import { Paginated } from "../../../shared/types/IPaginationResponse";

export const taskApi = {
  search: (params: TaskFilters & { page: number }) =>
    apiClient.get<Paginated<TaskListItem>>("/tasks", { params }),

  getById: (id: number) =>
    apiClient.get<Task>(`/tasks/${id}`),

  create: (dto: CreateTaskDto) =>
    apiClient.post<Task>("/tasks", dto),

  update: (id: number, dto: UpdateTaskDto) =>
    apiClient.patch<Task>(`/tasks/${id}`, dto),

  start: (id: number, dto: StartTaskDto) =>
    apiClient.post<Task>(`/tasks/${id}/start`, dto),

  complete: (id: number, dto: CompleteTaskDto) =>
    apiClient.patch<Task>(`/tasks/${id}/complete`, dto),

  schedule: (id: number, dto: ScheduleTaskDto) =>
    apiClient.patch<Task>(`/tasks/${id}/schedule`, dto),

  delete: (id: number) =>
    apiClient.delete(`/tasks/${id}`),

  getTechnicianTasks: (technicianId: number, params: { from: string; to: string }) =>
    apiClient.get<TechnicianTasksResponse>(`/tasks/technician/${technicianId}`, { params }),
};
